import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Avatar,
  Box,
  Chip,
  IconButton,
  Stack,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material';
import { HttpService } from 'core/services/http';
import { performAppLogout } from 'core/auth/performAppLogout';
import { useAuth0 } from "@auth0/auth0-react";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import NotificationDropdown from '../components/NotificationDropdown';

const JobseekerHeader = ({ onMenuClick, drawerWidth }) => {
  const location = useLocation();
  const queryClient = useQueryClient();
  const user = HttpService.getUser?.() ?? null;
  const { isAuthenticated: isAuth0Authenticated, logout: auth0Logout } = useAuth0();
  
  const handleLogout = () => {
    performAppLogout(queryClient, {
      isAuth0Authenticated,
      auth0Logout,
    });
  };

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === '/jobseeker/dashboard') return 'Dashboard';
    if (path === '/jobseeker/profile' || path === '/profile') return 'My Profile';
    if (path === '/jobseeker/applications') return 'My Applications';
    if (path === '/jobseeker/cvs') return 'My CVs';
    return 'Jobseeker Dashboard';
  };

  const initials = user?.email?.[0]?.toUpperCase() ?? user?.first_name?.[0] ?? 'J';

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: { md: `calc(100% - ${drawerWidth ?? 0}px)` },
        ml: { md: `${drawerWidth ?? 0}px` }
      }}
    >
      <Toolbar sx={{ minHeight: 72, px: { xs: 2, md: 4 } }}>
        <IconButton
          edge="start"
          color="inherit"
          sx={{ mr: 2, display: { md: 'none' } }}
          onClick={onMenuClick}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {/* <Typography variant="subtitle2" color="text.secondary">
            Welcome back
          </Typography> */}
          {/* <Typography variant="h6" fontWeight={600}>
            {getPageTitle()}
          </Typography> */}
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Chip label="Jobseeker" color="primary" variant="outlined" />
          <NotificationDropdown />
          <Tooltip title="Sign out">
            <IconButton color="inherit" onClick={handleLogout}>
              <LogoutOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Avatar sx={{ bgcolor: 'primary.main' }}>{initials}</Avatar>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default JobseekerHeader;

